import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { concatMap, finalize, tap } from 'rxjs/operators';

import { AuthService } from '../../../../services/auth.service';
import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';

import { coReviewViewModel } from '../../../../models/comodel/coreviewviewmodel.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { chiefsOrderReviewStatus } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { Note } from "../../../../common/models/note.model";
import { NoteType } from "../../../../common/models/note-type.enum";
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';

@Component({
    selector: 'co-cancel',
    templateUrl: './co-cancel.component.html',
    styleUrls: ['./co-cancel.component.scss'],
    standalone: false
})
export class CoCancelComponent implements OnInit, OnDestroy {

    @Input() coInstanceId: string;
    @Input() coreReviewModel: coReviewViewModel;
    @Output() setCurrentView = new EventEmitter<string>();
    @Output() setCoreReviewModel = new EventEmitter<coReviewViewModel | null>();
    cancelText: string = '';
    isInternalVal: boolean = false;
    title: string = '';
    subscription = new Subscription();
    subHeader: SubHeader = new SubHeader({ title: this.title });

    confirmCancelDialog: Dialog = new Dialog("This Chief's Order Application has been cancelled.", [new DialogButton("OK", true, () => this.onDialogConfirm())]);

    constructor(
        private activeRoute: ActivatedRoute,
        private chiefsOrderService: ChiefsOrderService,
        private readonly loader: LoaderService,
        private router: Router,
        public dialogService: DynamicDialogService,
        private subHeaderService: SubHeaderService,
        private _authService: AuthService
    ) { }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }

    goToReview(): void{
        this.setCurrentView.emit('review-chiefsorder');
    }

    cancelCO(): void {
        this.loader.toggleLoader(true);
        //Add whatever was entered as reason for Cancellation to the notes.
        const note = {
            documentType: "Note",
            isDeleted: false,
            createdDate: undefined,
            createdById: this._authService.User.id,
            createdBy: this._authService.User.displayName,
            type: (this.isInternalVal) ? NoteType.Internal : NoteType.General,
            text: this.cancelText
        } as Note;
        this.coreReviewModel.notes.push(note);

        const res$ = this.chiefsOrderService.savereviewnote(this.coreReviewModel).pipe(tap((response) => {
            this.coreReviewModel = response;
            this.setCoreReviewModel.emit(response);
        }),
        concatMap(() => {
            this.coreReviewModel.currentReview.reviewStatus = chiefsOrderReviewStatus.Cancelled;
            return this.chiefsOrderService.cancelco(this.coreReviewModel);
        }),
        finalize(() => { this.subscription.add(res$); })).subscribe(x => {
            this.loader.toggleLoader(false);
            var msg = this.coreReviewModel.templateName;
            this.confirmCancelDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.confirmCancelDialog);
            
        }, error => {
                console.log(error)
                this.loader.toggleLoader(false);
        });
    }

    public onDialogConfirm(): void {
        this.router.navigate(["/dashboard/view/ricsDashboard"]);
    }

}
